<template>
    <div class="faq">
        <div class="mobil_padding">
            <router-link class="header__pricing" :to="{ name: 'setting' }">
                <div class="img__pricing">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="13" viewBox="0 0 17 13" fill="none">
                        <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.57391 12.4252C7.30054 12.6986 6.85732 12.6986 6.58396 12.4252L1.15341 6.99466C0.880043 6.72129 0.880043 6.27808 1.15341 6.00471L6.58396 0.574165C6.85732 0.300798 7.30054 0.300798 7.57391 0.574165L8.17495 1.17521C8.44831 1.44857 8.44831 1.89179 8.17495 2.16516L4.96484 5.37526L16.2482 5.37526C16.594 5.37526 16.875 5.67788 16.875 6.05026V6.95026C16.875 7.32263 16.594 7.62526 16.2482 7.62526L4.96599 7.62526L8.17495 10.8342C8.44831 11.1076 8.44831 11.5508 8.17495 11.8242L7.57391 12.4252Z"
                        />
                    </svg>
                </div>
                <!-- <div class="back__pricing">
                    <Typography :weigth="'weigth'" :size="'bigger'">FAQ</Typography>
                </div> -->
            </router-link>
        </div>

        <div class="faq-content">
            <div class="faq-title">
                <Typography :weigth="'weigth'" :size="'biggest'">FAQ</Typography>
            </div>

            <div class="faq-list">
                <div class="faq-item" v-for="item in faqMock" :key="item.id">
                    <Typography :weigth="'weigth'" :size="'bigger'">{{ item.title }}</Typography>
                    <Typography class="faq-muted" :size="'small'">{{ item.content }}</Typography>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Typography from '../../../components/UI/Typography.vue';

export default {
    components: {
      Typography  
    },
    data() {
        return {
            faqMock: [
                { id: 1, title: 'How does Sleep Well work?', content: 'Content will be added later' },
                { id: 2, title: 'Principle of recommendations', content: 'Content will be added later' },
                { id: 3, title: 'How to extend / cancel subscription', content: 'Content will be added later' },
                { id: 4, title: 'Safety and medical limitations', content: 'Content will be added later' },
                { id: 5, title: 'Pricing plans and differences', content: 'Content will be added later' },
                { id: 6, title: 'Contact for feedback', content: 'Content will be added later' },
            ],
        };
    },
}
</script>
<style>
    .faq-content {
        padding: 16px;
    }
    .faq-title {
        margin-bottom: 16px;
    }
    .faq-list {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
    .faq-item {
        padding: 16px 0;
        border-bottom: 0.5px solid var(--typograohy-color);
    }
    .faq-muted {
        opacity: 0.7;
        margin-top: 6px;
    }
</style>